import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from '../services/auth-store.service';

export const adminGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  await authStore.initialize();

  if (!authStore.isAuthenticated()) {
    return router.createUrlTree(['/login'], {
      queryParams: {
        redirect: '/admin',
      },
    });
  }

  if (authStore.isAdmin()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
